// @mui
import { Box } from '@mui/material';
import { ServiceProps } from 'src/@types/service';
import ServiceItem from './ServiceItem';

// ----------------------------------------------------------------------

type Props = {
  services: ServiceProps[];
};

export default function ServicesList({ services }: Props) {
  // const [selected, setSelected] = useState('All');

  // const getCategories = services.map((seservice) => seservice.frontmatter.category);

  // const categories = ['All', ...Array.from(new Set(getCategories))];

  // const filtered = applyFilter(services, selected);

  // const handleChangeCategory = (event: React.SyntheticEvent, newValue: string) => {
  //   setSelected(newValue);
  // };

  return (
    <>
      <Box
        sx={{
          pt: 5,
          pb: { xs: 5, md: 10 },
        }}
      >
        {/* <Tabs
          value={selected}
          scrollButtons="auto"
          variant="scrollable"
          allowScrollButtonsMobile
          onChange={handleChangeCategory}
        >
          {categories.map((category) => (
            <Tab key={category} value={category} label={category} />
          ))}
        </Tabs> */}
      </Box>

      <Box
        sx={{
          display: 'grid',
          rowGap: { xs: 4, md: 5 },
          columnGap: { xs: 2, md: 2 },
          gridTemplateColumns: {
            xs: 'repeat(2, minmax(0, 1fr))',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
        }}
      >
        {services?.map((service) => (
          <ServiceItem key={service.slug.current} service={service} />
        ))}
      </Box>

      {/* <Pagination
        count={10}
        color="primary"
        size="large"
        sx={{
          pt: 10,
          pb: { xs: 10, md: 15 },
          '& .MuiPagination-ul': {
            justifyContent: 'center',
          },
        }}
      /> */}
    </>
  );
}

// ----------------------------------------------------------------------

// function applyFilter(arr: CaseStudyProps[], category: string) {
//   if (category !== 'All') {
//     arr = arr.filter((seservice) => seservice.frontmatter.category === category);
//   }
//   return arr;
// }
